module["exports"] = [
  "##-###"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/pl/address/postcode.js
// module id = 880
// module chunks = 0